import { z as Z, ZodEffects, ZodString } from "zod";
import { isValidCNPJ, isValidCPF } from "@repo/core/helpers/zod.helpers"; // Ajuste o caminho conforme necessário

declare module "zod" {
  interface ZodString {
    cnpj: (message?: string) => ZodEffects<ZodString, string, string>;
    cpf: (message?: string) => ZodEffects<ZodString, string, string>;
  }
}

ZodString.prototype.cnpj = function (message = "CNPJ inválido") {
  return this.refine(isValidCNPJ, {
    message
  });
};

ZodString.prototype.cpf = function (message = "CPF inválido") {
  return this.refine(isValidCPF, {
    message
  });
};

export { Z };
